import { SquareParking, Plane, MailPlus, LandPlot } from "lucide-react";
import { useTranslations } from "next-intl";

export function useNavItems() {
  const t = useTranslations("nav");
  return [
    {
      label: t("vuelos.label"),
      title: t("vuelos.title"),
      description: t("vuelos.description"),
      iconSrc: Plane,
      linkHref: "/vuelos",
      titleButton: t("vuelos.titleButton"),
      links: [
        { label: t("vuelos.links.saliendo"), href: "/vuelos?tipo=salida" },
        { label: t("vuelos.links.llegando"), href: "/vuelos?tipo=llegada" },

        { label: t("vuelos.links.recomendaciones"), href: "/recomendaciones" },
        { label: t("vuelos.links.scaner"), href: "/scaner" },

        { label: t("experiencias.links.salas"), href: "/informacion/salasvip" },
        // { label: "Fast-Track", href: "/fast-track" }, // Oculto en producción (ver app/lib/config.ts)
        { label: t("vuelos.links.conexiones"), href: "/conexion" },
      ],
    },
    {
      label: t("transporte.label"),
      title: t("transporte.title"),
      description: t("transporte.description"),
      iconSrc: SquareParking,
      linkHref: "/transporte",
      titleButton: t("transporte.titleButton"),
      links: [
        { label: t("transporte.links.taxi"), href: "/transporte/taxi" },
        { label: t("transporte.links.metrobus"), href: "/transporte/metrobus" },
        {
          label: t("transporte.links.shuttle"),
          href: "/transporte/shuttlebus",
        },
        {
          label: t("transporte.links.parking"),
          href: "/transporte/estacionamientos",
        },
        { label: t("transporte.links.metro"), href: "/transporte/metro" },
        {
          label: t("transporte.links.alquiler"),
          href: "/transporte/alquiler-autos",
        },
      ],
    },
    {
      label: t("informacion.label"),
      title: t("informacion.title"),
      description: t("informacion.description"),
      iconSrc: MailPlus,
      linkHref: "/buzon-sugerencias",
      titleButton: t("informacion.titleButton"),
      links: [
        { label: t("informacion.links.informacion"), href: "/informacion" },
        { label: t("informacion.links.noticias"), href: "/noticias" },
        { label: t("informacion.links.corporativo"), href: "/corporativo" },
        {
          label: t("informacion.links.atencion"),
          href: "/pasajeros",
        },
        { label: t("informacion.links.regional"), href: "/aeropuertos" },
        { label: t("informacion.links.carga"), href: "/carga" },
      ],
    },
    {
      label: t("experiencias.label"),
      title: t("experiencias.title"),
      description: t("experiencias.description"),
      iconSrc: LandPlot,
      linkHref: "/eventos",
      titleButton: t("experiencias.titleButton"),
      links: [
        { label: t("experiencias.links.restaurantes"), href: "/restaurantes" },
        { label: t("experiencias.links.tiendas"), href: "/tiendas" },
        { label: t("experiencias.links.eventos"), href: "/eventos" },
        // { label: t("experiencias.links.marketplace"), href: "/marketplace" }, // Oculto en producción (ver app/lib/config.ts)
      ],
    },
  ];
}
